/**
 * Просмотр MHTML: in-app модалки используют /api/raw_page (HTML с data: URI),
 * публичные ссылки — /api/view_mhtml (обёртка с iframe).
 */

export function getRawPagePath(taskId) {
  return `/api/raw_page/${taskId}`;
}

export function getMhtmlViewPath(taskId) {
  return `/api/view_mhtml/${taskId}`;
}

export function isMhtmlViewUrl(url) {
  return typeof url === 'string' && url.includes('/view_mhtml/');
}

export function mhtmlViewUrlToRawPage(url) {
  return url.replace('/view_mhtml/', '/raw_page/');
}

export function revokeViewBlobUrl(url) {
  if (url?.startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }
}

/**
 * Загружает конвертированную HTML-страницу (raw_page) и возвращает blob: URL для iframe.
 */
export async function fetchRawPageBlobUrl(taskId, { headers = {} } = {}) {
  const response = await fetch(getRawPagePath(taskId), { headers });

  if (!response.ok) {
    let message = 'Не удалось загрузить страницу';
    try {
      const data = await response.json();
      message = data.error || message;
    } catch {
      const text = await response.text();
      if (text) message = text.slice(0, 200);
    }
    throw new Error(message);
  }

  const contentType = response.headers.get('content-type') || 'text/html; charset=utf-8';
  const blob = await response.blob();
  return URL.createObjectURL(new Blob([blob], { type: contentType }));
}

/**
 * Для URL вида /api/view_mhtml/... возвращает blob: URL через raw_page.
 */
export async function fetchPageViewBlobUrl(url, { headers = {} } = {}) {
  const fetchUrl = isMhtmlViewUrl(url) ? mhtmlViewUrlToRawPage(url) : url;
  const response = await fetch(fetchUrl, { headers });

  if (!response.ok) {
    throw new Error('Не удалось загрузить страницу');
  }

  const contentType = response.headers.get('content-type') || 'text/html; charset=utf-8';
  const blob = await response.blob();
  return URL.createObjectURL(new Blob([blob], { type: contentType }));
}
